export * from 'shared/storages/grid.storage';
export * from 'shared/storages/bar.storage';
export * from 'shared/storages/gameHeader.storage';
export * from 'shared/storages/counter.storage';
export * from 'shared/storages/mechanic.storage';
export * from 'shared/storages/score.storage';
export * from 'shared/storages/gameView.storage';
export * from 'shared/storages/locElements.storage';
export * from 'shared/storages/map.storage';
export * from 'shared/storages/language.storage';
export * from 'shared/storages/isStartMusic.storage';
